import { formatEther } from "viem";
import { useAccount, useBalance } from "wagmi";

export const useGetEthBalance = (network) => {

	const { address: account } = useAccount();
	
	const { status, refetch, data } = useBalance({
	chainId: network === "BNB" ? 56 : 1,
	address: account,
	enabled: !!account,
	});
   console.log("🦁 ~ useGetEthBalance ~ data:", data)
   
	return {
	balance: data?.value ? parseFloat(formatEther(data.value)) : 0,
	fetchStatus: status,
	refreshEth: refetch,
	};
   };


export const useGetTokenBalance = () => {

	const { address: account } = useAccount();
	
	const { status, refetch, data } = useBalance({
	chainId: 56,
	address: account,
	enabled: !!account,
    token: "0xFe712Ebe45bf3203b031d0520CDc6228b4e75e8E"
	});
   console.log("🦁 ~ useGetEthBalance ~ data:", data)
   
	return {
	balance: data?.value ? parseFloat(formatEther(data.value)) : 0,
	fetchStatus: status,
	refreshEth: refetch,
	};
   };